<template>
  <footer class="p-3">
    <div class="container">
      <h5>
        W <strong>Carspot24</strong> pomagamy kierowcom rozwiązywać ich problemy
      </h5>
      <a
        :href="`mailto:${getEmail}`"
        class="text-decoration-none text-white mt-md"
      >
        <div class="row mt-4">
          <div class="col-2"><mail-icon /></div>
          <div class="col-8">
            <strong>{{ getEmail }}</strong>
          </div>
        </div>
      </a>
      <div class="row mt-2">
        <div class="col-2"></div>
        <div class="col-8">
          <span>W razie wątpliwości odpowiemy na twoje pytania</span>
        </div>
      </div>
      <a
        :href="`tel:${getPhoneNumber}`"
        class="text-decoration-none text-white"
      >
        <div class="row mt-4">
          <div class="col-2"><phone-icon /></div>
          <div class="col-8">
            <strong>{{ getPhoneNumber }}</strong>
          </div>
        </div>
      </a>
      <div class="row mt-2">
        <div class="col-2"></div>
        <div class="col-8">
          <span
            >Jeśli wolisz zadzwonić, jesteśmy dostępni pon - pt, 10 - 16</span
          >
        </div>
      </div>

      <div class="row mt-md">
        <a
          :href="getRegulations"
          class="text-white"
          target="_blank"
          rel="noopener noreferrer"
          >Regulamin serwisu</a
        >
      </div>
      <div class="row">
        <a
          :href="getPrivacyPolicy"
          class="text-white"
          target="_blank"
          rel="noopener noreferrer"
          >Polityka prywatności</a
        >
      </div>
      <div class="row">
        <router-link
          :to="{ name: 'cookies-declaration-settings' }"
          class="text-white"
          >Ustawienia cookies</router-link
        >
      </div>

      <div class="row mt-sm">
        <p>
          <strong>Carspot24.pl</strong> prowadzony jest przez Comparison One Sp.
          z o. o., Elekcyjna 19/3, <br />
          01-128 Warszawa.
        </p>
      </div>

      <div class="row mt-md">
        <p>Wszelkie prawa zastrzeżone. © 2022 - 2023</p>
      </div>
    </div>
  </footer>
</template>
<script>
import MailIcon from "@/components/icons/MailIcon";
import { mapGetters } from "vuex";
import PhoneIcon from "@/components/icons/PhoneIcon";
export default {
  components: { PhoneIcon, MailIcon },
  computed: {
    ...mapGetters([
      "getEmail",
      "getPhoneNumber",
      "getRegulations",
      "getPrivacyPolicy",
    ]),
  },
};
</script>
<style scoped>
footer {
  background-color: var(--brand-color);
  color: white;
  margin-top: 120px;
}

.container {
  max-width: 840px !important;
}
</style>
